import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaleAreaComponent } from './charts/scale-area/scale-area.component';
import { StackedAreaComponent } from './charts/stacked-area/stacked-area.component';
import { PieLegendComponent } from './charts/pie-legend/pie-legend.component';
import { BarChartComponent } from './charts/bar-chart/bar-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ChartsModule } from 'ng2-charts';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';


@NgModule({
  declarations: [
    ScaleAreaComponent,
    StackedAreaComponent,
    PieLegendComponent,
    BarChartComponent,
  ],
    imports: [
        CommonModule,
        NgxEchartsModule,
        ChartsModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        MatSliderModule,
    ],
  exports: [
    ScaleAreaComponent,
    StackedAreaComponent,
    PieLegendComponent,
    BarChartComponent,
  ]
})
export class ChartComponentsModule {
}
